import React, { Component } from 'react'
import { connect } from 'react-redux';

import { loginUser, loginUserCheck } from '../redux/actions'

class Adminlogin extends Component {

	constructor(props) {
		super(props)
		this.state = {
			email: '',
			password: '',
			secret: ''
		}
	}

	componentWillMount() {
		this.props.loginUserCheck("login")
	}

	_onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
	}

	_onLogin() {
		const { email, password } = this.state;
		this.props.loginUser(email, password); 
	}

	render() {
		return (
			<div className="admin-login">
				<div className="container">
					<div className="form-login">
						<h4>Sign in to your account</h4>
						<form>
							<div className="form-group">
								<label htmlFor="name">Email Address</label>
								<input type="email" className="form-control" name="email" onChange={(event) => this._onHandleChange(event)} />
							</div>
							<div className="form-group">
								<label htmlFor="email">Password</label>
								<input type="password" className="form-control" name="password" onChange={(event) => this._onHandleChange(event)} />
							</div>
							<div className="form-btn">
								<p style={{color: 'red'}}>{this.props.errorLogin}</p>
								{
									(this.props.loading) ?
									'Loading...'
									: <button className="btn-login" onClick={() => this._onLogin()}>Login</button>
								}
							</div>
							
						</form>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ({auth}) => {
	const { loading, errorLogin } = auth;
	return {
		loading, errorLogin
	};
}

export default connect(mapStateToProps, { 
    loginUser, loginUserCheck 
})(Adminlogin)